export const brandIsDefault = {
  type: "boolean"
};
